var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "text-h5 q-mt-lg q-mb-md" }, [
        _vm._v(_vm._s(_vm.$t(_vm.game_data.game_name)))
      ]),
      _c(
        "q-collapsible",
        {
          staticClass: "shadow-2 q-pa-sm q-ma-xs rounded-border",
          attrs: {
            icon: "far fa-ballot-check",
            "right-icon": "far fa-ballot-check",
            label: _vm.$t("how_to_create_the_game")
          }
        },
        [
          _c("div", { staticClass: "q-ma-sm" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("flashcards_instructions")))]),
            _c("p", { staticClass: "q-mt-lg" }, [
              _c("em", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("warning") + ": "))]),
                _vm._v(_vm._s(_vm.$t("create_game_before_save")))
              ])
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 q-mb-md" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("uploader", {
                  staticClass: "q-mt-xs",
                  attrs: {
                    content_type: "images",
                    multiple: false,
                    cropper: true,
                    aspect_ratio: 1 / 1,
                    aspect_ratio_string: "1/1"
                  },
                  on: { fileUploaded: _vm.imageUploaded }
                }),
                _vm.game_data.images.length
                  ? _c(
                      "q-list",
                      {
                        staticClass: "q-mt-md",
                        attrs: {
                          dense: "",
                          bordered: "",
                          padding: "",
                          separator: ""
                        }
                      },
                      _vm._l(_vm.game_data.images, function(image, index) {
                        return _c(
                          "q-item",
                          { key: index },
                          [
                            _c("q-item-tile", { staticClass: "q-mr-sm" }, [
                              _c("img", {
                                staticStyle: { width: "9rem" },
                                attrs: { src: image.image_link_signed }
                              })
                            ]),
                            _c(
                              "q-item-main",
                              { staticClass: "q-mx-sm" },
                              [
                                _c(
                                  "q-field",
                                  { attrs: { count: 200 } },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        error:
                                          _vm.$v.game_data.images.$each[index]
                                            .description.$error,
                                        "float-label": _vm.$t("description")
                                      },
                                      on: {
                                        input:
                                          _vm.$v.game_data.images.$each[index]
                                            .description.$touch
                                      },
                                      model: {
                                        value: image.description,
                                        callback: function($$v) {
                                          _vm.$set(image, "description", $$v)
                                        },
                                        expression: "image.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-field",
                                  {
                                    staticClass: "q-mb-sm",
                                    attrs: { count: 80 }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        error:
                                          _vm.$v.game_data.images.$each[index]
                                            .answer.$error,
                                        "float-label": _vm.$t("correct_answer")
                                      },
                                      on: {
                                        input:
                                          _vm.$v.game_data.images.$each[index]
                                            .answer.$touch
                                      },
                                      model: {
                                        value: image.answer,
                                        callback: function($$v) {
                                          _vm.$set(image, "answer", $$v)
                                        },
                                        expression: "image.answer"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-item-side",
                              { attrs: { right: "" } },
                              [
                                image.image_link.length && image.answer.length
                                  ? _c("q-icon", {
                                      attrs: {
                                        name: "fal fa-check",
                                        color: "positive"
                                      }
                                    })
                                  : _vm._e(),
                                _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      round: "",
                                      flat: "",
                                      color: "negative",
                                      icon: "fal fa-trash"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFile(image)
                                      }
                                    }
                                  },
                                  [
                                    _c("q-tooltip", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("remove")) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "row justify-end q-mr-md q-mt-md" },
                  [
                    _c("q-btn", {
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("preview"),
                        disable: _vm.disableGamePreview
                      },
                      on: { click: _vm.buildGamePreview }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm.show_game_preview
        ? _c("flashcards-preview", {
            attrs: {
              show_game_preview: _vm.show_game_preview,
              game_name: _vm.game_data.game_name,
              images: _vm.game_data.images
            },
            on: {
              hide_preview: function($event) {
                return _vm.hidePreview()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }